<template>
	<div>
		<h1 class="h3 mb-3 text-gray-800">
			{{ $t("Registro de Atividades no Sistema") }}
		</h1>

		<b-card class="shadow">
			<div class="list-auditoria-component">
				<div class="row">
					<div class="col-12">
						<div class="d-flex align-items-center justify-content-between mb-4">
							<div>
								<div class="input-group mb-3">
									<b-input
										:placeholder="$t('Type to search')"
										class="form-control search-input"
										type="text"
										v-model="search"
										v-on:change="getAuditorias"
										aria-describedby="input-search"
									/>
									<div class="input-group-append" role="button">
										<span class="input-group-text" id="input-search"
											><i class="fas fa-search search-icon"
										/></span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12">
						<loading-animation
							:active.sync="loading"
							:is-full-page="false"
							:opacity="1"
							color="#5895FF"
						/>
						<b-table
							:fields="[
								{
									key: 'event',
									label: $t('Evento'),
								},
								{
									key: 'user_id',
									label: $t('Usuário'),
								},
								{
									key: 'infos',
									label: $t('Detalhes'),
								},
							]"
							:items="auditoriaList"
							:responsive="true"
							striped
							hover
							show-empty
							small
							outlined
							stacked="md"
							table-class="mb-3"
						>
							<template v-slot:cell(event)="data">
								{{ data.value }}<br />
								<i class="mdi mdi-calendar-month"></i> {{ data.item.created_at }}
							</template>
							<template v-slot:cell(new_values)="data">
								<span class="font-weight-bold">{{ data.user_id }}</span>
							</template>
							<template v-slot:cell(infos)="data">
								<button
									class="btn btn-sm btn-primary"
									@click="
										$bvModal.show('modal-detalhes-auditoria');
										itemSelected = data.item;
									"
								>
									<i class="mdi mdi-text-box-search-outline"></i>
								</button>
							</template>
							<template v-slot:empty="scope">
								<div class="text-center my-5">
									<img
										:alt="$t('No results')"
										class="mb-5"
										src="/img/icons/robot.svg"
										style="max-height: 165px"
									/>
									<h3 class="bold">{{ $t("No records found") }}</h3>
								</div>
							</template>
						</b-table>

						<div class="row align-items-center">
							<div class="col-lg-6 col-md-12">
								<div class="form-group d-inline-flex mb-0">
									<select
										class="form-control"
										style="width: 70px"
										v-model="perPage"
										v-on:change="getAuditorias"
									>
										<option value="5">5</option>
										<option value="10">10</option>
										<option value="25">25</option>
										<option value="50">50</option>
									</select>
								</div>
								<div class="d-inline-flex ml-2">
									<b-pagination
										:per-page="perPage"
										:total-rows="pagination.total"
										@change="changePage"
										v-model="page"
									/>
								</div>
							</div>
							<div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
								<div class="float-lg-right">
									{{ $t("Showing page") }} {{ pagination.currentPage }} {{ $t("of") }}
									{{ pagination.totalPages }}
									{{ $t("pages in") }}
									{{ pagination.total }}
									{{ $t("records") }}
								</div>
							</div>
						</div>
					</div>
					<router-view />
				</div>
			</div>
		</b-card>
		<Detalhes :item="itemSelected"></Detalhes>
	</div>
</template>

<script>
import Detalhes from "./Detalhes";
export default {
	components: { Detalhes },
	name: "Auditorias",
	metaInfo() {
		return {
			title: this.$i18n.t("Registro de Atividades no Sistema"),
		};
	},
	data() {
		return {
			itemSelected: [],
			page: 1,
			search: "",
			perPage: 10,
			loading: true,
			pagination: {
				currentPage: 0,
				perPage: 0,
				total: 0,
				totalPages: 0,
			},
			auditoriaList: [],
		};
	},
	mounted() {
		this.getAuditorias();
	},
	methods: {
		changePage(page) {
			if (page > 0 && page <= this.pagination.totalPages && page !== this.page) {
				this.page = page;
				this.getAuditorias();
			}
		},
		getAuditorias() {
			this.loading = true;
			axios
				.get("api/dashboard/auditoria", {
					params: {
						page: this.page,
						search: this.search,
						perPage: this.perPage,
					},
				})
				.then((response) => {
					this.auditoriaList = response.data.data;
					this.pagination = response.data.pagination;
					if (this.pagination.totalPages < this.pagination.currentPage) {
						this.page = this.pagination.totalPages;
						this.getAuditorias();
					} else {
						this.loading = false;
					}
				})
				.catch(() => {
					this.loading = false;
				});
		},
	},
};
</script>
